if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('btn--loading');
      let productUrl = opener.getAttribute('data-product-url');
      if (productUrl.indexOf("?") > -1) {
        const productUrlSplit = productUrl.split('?');
        productUrl = productUrlSplit[0];
      }

      fetch(`${productUrl}?section_id=product-quick-buy`)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('div[id^="product-quick-buy"]');

          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.classList.remove('hide-popup');

          document.body.setAttribute("active-popup", 'quick-add-modal');
          document.querySelectorAll('.theme-popup-overlay').forEach(el => el.classList.remove('hidden-overlay'));
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('btn--loading');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
  });

  const currencyFormat = window.cartStrings.currencyCodeEnabled ? window.cartStrings.moneyWithCurrencyFormat : window.cartStrings.moneyFormat;
  console.log(currencyFormat);
  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.cartStrings.moneyFormat;

    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      let parts = number.split(".");
      let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      let centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }

    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  document.addEventListener('change', function (event) {
  if (!event.target.classList.contains('js-option-select')) return;

  // console.log("Event triggered by:", event.target);

  const select = event.target;
  const form = select.closest('form');
  const modal = select.closest('.quick-add-modal');

  if (!form) {
    console.warn('Form not found.');
    return;
  }

  const jsonScript = form.querySelector('#product-data-json');
  if (!jsonScript) {
    console.warn('Product JSON script not found.');
    return;
  }

  let productData;
  try {
    productData = JSON.parse(jsonScript.textContent);
    console.log('Parsed productData:', productData);
  } catch (e) {
    console.error('Invalid product JSON:', e);
    return;
  }

  // Compose variantOption string from all option selects, assuming variant title matches option1/option2/... combined
  // If your variant title is just option1, you can simplify accordingly
  let variantOption = '';
  const optionElements = form.querySelectorAll('.js-option-select');
  optionElements.forEach((el, idx) => {
    const val = el.value;
    console.log(`Option ${idx + 1} value:`, val);
    variantOption += (idx === 0 ? '' : ' / ') + val;
  });

  // console.log('Constructed variantOption string:', variantOption);

  if (productData['variants']) {
    let matched = false;
    productData['variants'].forEach(function (variant) {
      // Match by title string (e.g. "Small / Red / Large")
      if (variant.title === variantOption) {
        matched = true;

        const variantId = variant.id;
        const variantPrice = formatMoney(variant.price, currencyFormat);
        const variantComparePrice = variant.compare_at_price;
        const variantAvailable = variant.available;

        // Update hidden variant ID input
        const variantIdInput = form.querySelector('[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = variantId;
          // console.log('Updated variant ID:', variantId);
        }

        // Update price display
        if (modal) {
          const priceContainer = modal.querySelector('.price');
          if (priceContainer) {
            const saleSpan = priceContainer.querySelector('span[price--sale]');
            const regularSpan = priceContainer.querySelector('span[price--regular]');
            if (variantComparePrice) {
              if (saleSpan) saleSpan.innerHTML = variantPrice;
              if (regularSpan) {
                regularSpan.classList.add('cut--price');
                regularSpan.innerHTML = formatMoney(variantComparePrice, currencyFormat);
              }
            } else {
              if (saleSpan) saleSpan.innerHTML = '';
              if (regularSpan) {
                regularSpan.classList.remove('cut--price');
                regularSpan.innerHTML = variantPrice;
              }
            }
            // console.log('Updated price display.');
          }

          // Update product image
          if (variant.featured_image && variant.featured_image.src) {
            const productImage = modal.querySelector('.quickBuy--product-image');
            if (productImage) {
              productImage.src = variant.featured_image.src + '?&width=300';
              console.log('Updated product image.');
            }
          }
        }

        // Update Add to Cart button state
        const addButton = form.querySelector('.quick-add__submit[name="add"]');
        if (addButton) {
          const spnAdd = addButton.querySelector('.spn--add');
          const soldOutMsg = addButton.querySelector('.sold-out-message');

          if (variantAvailable) {
            addButton.disabled = false;
            addButton.removeAttribute('aria-disabled');
            spnAdd?.classList.remove('hidden');
            soldOutMsg?.classList.add('hidden');
            // console.log('Variant is available – enabled Add button.');
          } else {
            addButton.disabled = true;
            spnAdd?.classList.add('hidden');
            soldOutMsg?.classList.remove('hidden');
            // console.log('Variant is sold out – disabled Add button.');
          }
        }
      }
    });

    if (!matched) {
      // console.warn('No matching variant found for selected option:', variantOption);
    }
  } else {
    // console.warn('No variants found in product data.');
  }
});

}
